module.exports = __webpack_public_path__ + "img/category-labware.5468d7e3.png";